export const CHANGE_SEARCHFIELD = 'CHANGE_SEARCHFIELD';
export const CHANGE_NAME = 'CHANGE_NAME';
export const CHANGE_USERNAME = 'CHANGE_USERNAME';
export const CHANGE_EMAIL = 'CHANGE_EMAIL';
export const ADD_ROBOT = 'ADD_ROBOT';
export const CHANGE_ID = 'CHANGE_ID';
export const UPDATE_ROBOT = 'UPDATE_ROBOT';
export const DELETE_ROBOT = 'DELETE_ROBOT';
export const REQUEST_ROBOTS_PENDING = 'REQUEST_ROBOTS_PENDING';
export const REQUEST_ROBOTS_SUCCESS = 'REQUEST_ROBOTS_SUCCESS';
export const REQUEST_ROBOTS_FAILED = 'REQUEST_ROBOTS_FAILED';
export const DELID = 'DELID';
export const LALA = 'LALA';
export const UPNAME = 'UP_NAME';
export const UPUSERNAME = 'UP_USERNAME';
export const UPEMAIL = 'UP_EMAIL';